export function useExportToCSV(rows, columns) {
    const exportToCSV = (fileName) => {
        let csv = 'data:text/csv;charset=utf-8,';

        csv += columns.value.map(column => `"${column.label}"`) + `\r\n`;

        const fields = columns.value.map(column => column.field);

        rows.value.forEach((row) => {
            csv += fields.map((field) => `"${row.raw[field]}"`).join() + `\r\n`;
        });

        const link = document.createElement('a');

        link.setAttribute('href', encodeURI(csv));
        link.setAttribute('download', fileName);
        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
    };

    return {
        exportToCSV,
    };
}
